import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
    (r) => r,
    async (err) => {
        const orig = err.config;
        if (err.response?.status === 401 && orig && !orig._retry && !orig.url.includes("/auth/")) {
            orig._retry = true;
            try {
                refreshing = refreshing || api.post("/auth/refresh");
                await refreshing;
                refreshing = null;
                return api(orig);
            } catch (e) {
                refreshing = null;
            }
        }
        return Promise.reject(err);
    }
);

export function errMsg(e) {
    const d = e?.response?.data?.detail;
    if (!d) return "Something went wrong. Please try again.";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
    if (typeof d === "object" && typeof d.msg === "string") return d.msg;
    return String(d);
}

export function trackPage(path) {
    try {
        api.post("/track", { path }).catch(() => {});
    } catch (e) { /* analytics must never break the page */ }
}
